import React, { useEffect } from 'react';

const Hero = () => {
  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      const orbs = document.querySelectorAll('.gradient-orb');
      
      orbs.forEach((orb, index) => {
        const speed = 0.5 + (index * 0.1);
        orb.style.transform = `translateY(${scrolled * speed}px)`;
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>
      <div className="container">
        <div className="hero-content">
          <div className="hero-badge">
            <span>🌍 전 세계 어디서나</span>
          </div>
          <h1 className="hero-title">
            해외문자 발송을<br />
            <span className="gradient-text">간편하게</span>
          </h1>
          <p className="hero-description">
            안정적이고 빠른 해외 SMS 발송 서비스로<br />
            전 세계 고객과 소통하세요
          </p>
          <div className="hero-cta">
            <a href="#contact" className="btn-primary" onClick={(e) => scrollToSection(e, 'contact')}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
              </svg>
              텔레그램으로 문의하기
            </a>
            <a href="#features" className="btn-secondary" onClick={(e) => scrollToSection(e, 'features')}>
              자세히 알아보기
            </a>
          </div>
          <div className="hero-stats">
            <div className="stat-item">
              <div className="stat-number">200+</div>
              <div className="stat-label">지원 국가</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">99.9%</div>
              <div className="stat-label">전송 성공률</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">고객 지원</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
